import { SOURCE_ADMIN_SMS } from '@rsos/constants/locationSources';
import { type EmergencyLocation } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCalls.types';

/**
 * Returns a boolean determining if the eventpane will only have chat tab
 */
const getIsPrimaryChatTab = (mostRecentLocation?: EmergencyLocation | null) => {
  if (!mostRecentLocation) {
    return false;
  }
  const chatOnlySources = new Set([SOURCE_ADMIN_SMS]);

  return chatOnlySources.has(mostRecentLocation.source);
};

export default getIsPrimaryChatTab;
